<template>
  <v-container grid-list-xl class="pa-5">
    <v-row class="mb-5">
      <v-col cols="12" md="3">
        <BlockCard
          title="Tenant Terdaftar"
          :value="0"
          icon="mdi-account-tie"
          color="#FFB74D"
          icon-color="primary"
          icon-avatar-color="primary lighten-4"
          class="elevation-custom"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BlockCard
          title="Tenant Aktif"
          :value="0"
          icon="mdi-account-tie"
          class="elevation-custom"
          color="#F48C6C"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BlockCard
          title="Tenant Suspend"
          :value="0"
          icon="mdi-account-tie"
          color="#aaa5c6"
          class="elevation-custom"
          icon-color="blue lighten-1"
          icon-avatar-color="blue lighten-5"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BlockCard
          title="Tenant Non-aktif"
          :value="0"
          icon-color="amber lighten-1"
          icon-avatar-color="amber lighten-4"
          class="elevation-custom"
          color="#4DB6AC"
          icon="mdi-account-tie"
        />
      </v-col>
    </v-row>
    <m-card-list
      two-line
      title="Tenant"
      label-cari="Cari Tenant"
      add
      edit
      search
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>
            <router-link
              class="ok"
              :to="{
                    name: 'tenant.detail',
                    params: { no_reg: item.no_reg }
                  }">
              <v-avatar :size="40" color="grey lighten-4">
                <img :src="item.file_foto || 'img/organisasi-default.png'" alt="avatar" />
              </v-avatar>
              <span class="ml-1"> {{ pVal(item, "nama") }}</span>
            </router-link>
          </td>
          <td>{{ pVal(item, "no_reg") }}</td>
          <td>{{ pVal(item, "email") }}</td>
          <td>
            <m-menu
              left
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <router-link
                class="ok"
                :to="{
                      name: 'tenant.detail',
                      params: { no_reg: item.no_reg }
                    }"
              >{{ pVal(item, "nama") }}</router-link
              >
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "no_reg") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[2].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "email") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[3].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tenant ID", align: "left", value: "no_reg" },
        { text: "Surel", align: "left", value: "email" },
        { text: "", sortable: false }
      ],
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o)
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("tenant/get", { page: this.cp, keyword: this.textSearch })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
      `
      )
        .then(() => this.$store.dispatch("tenant/drop", item.no_reg))
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};

</script>

<style scoped>

.elevation-custom{
  -webkit-box-shadow: 0px 0px 20px 3px #4362be56 !important;
}
</style>
